// app fonts
const spotifyLight = require('../assets/fonts/spotify-light.ttf');
const spotifyRegular = require('../assets/fonts/spotify-regular.ttf');
const spotifyBold = require('../assets/fonts/spotify-bold.ttf');

export default [
  {
    spotifyLight,
    spotifyRegular,
    spotifyBold
  }
];
